import React, { useState } from 'react'
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaAddressCard, FaBook, FaCaretDown, FaCaretUp, FACaretUp, FaCartPlus, FaChartBar, FaCog, FaCreditCard, FaHistory, FaHome, FaKey, FaList, FaMailBulk, FaMicrosoft, FaPhotoVideo, FaPlus, FaPlusCircle, FaPoll, FaPollH, FaScrewdriver, FaStore, FaUser, FaUsers, FaVideo, FaVrCardboard } from 'react-icons/fa';
import { useSelector } from 'react-redux';

const SideNav = () => {
    const [subMenuOpen, setSubMenuOpen] = useState(false);
    const Navigate = useNavigate();
    const user = useSelector(state => state.user.payload);
    useEffect(() => {
        // console.log(window.innerWidth);
        if(window.innerWidth < "430"){
           let element =  document.getElementsByClassName('sidebar')[0];
            element.classList.add('close');
            // document.getElementsByClassName('bell')[0].classList.a 
            
        } 
    }, [])
  return (
    <div class="sidebar bg">
        
    <div id='logo' class="logo">
    <i class="image"> 
        {/* <FaUser /> */}
        <img src='/bsc.png'
          style={{ 
            borderRadius: '50%',
            width:'60px',
            height: '60px',
            // borderRadius: '10%'
           }}
          />
    </i>
    <span class="logo-name mx-1"
    style={{ 
        display: 'flex',
        justifyContent: 'space-between',
        alignContent: 'center'
        
     }}
    >
        
        {user.name}
        {/* {
            document.getElementById('logo') && 
            document.getElementById('logo').className == 'show' ?
            <FaCaretUp size={12} className='mt-1 ms-2'/> :
            <FaCaretDown size={18} className='mt-1 ms-2' />
        }  */}
    </span>
        {/* <ul style={{ 
            padding: "8px 2px 5px 75px",
            marginTop: "-10px",
            background: "#2a3431",
            display: 'none',
            transition: "all 0.3s ease",
            color: 'white'
         }}> 
            <li>
                Sign-out
            </li>
        </ul> */}
    </div>

    <ul class="nav-list">
    <li onClick={()=> {
        Navigate('dashboard')
        // console.log(window.innerWidth);
        if(window.innerWidth < '430'){
            let sidebar = document.querySelector(".sidebar");
            sidebar.classList.toggle("close");
        }
        }}>
        <a href="#">
        <i class=""><FaHome /></i>
        <span class="link-name">Dashboard</span>
        </a>

        <ul class="sub-menu blank">
        <li><a href="#" class="link-name">Dashboard</a></li>
        </ul>
    </li>
    <li id='sliders'
     onClick={(e) => {
        document.getElementById('sliders').classList.toggle('show');
        setSubMenuOpen(!subMenuOpen);
    }}
    >
        <div class="icon-link">
        <a href="#"  >
            <i><FaPhotoVideo /></i>
            <span class="link-name"> Sliders </span>
        </a>
        <i class="arrow" > {document.getElementById('slider') && document.getElementById('slider').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
        
        </div>

        <ul class="sub-menu">
        <li
        onClick={()=> {
            Navigate('addSlide')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaPlus className='me-1' />
            Add New Slider
            </a>
        </li>
        <li
        onClick={()=> {
            Navigate('sliders')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaList className='me-1' />
             View Sliders
            </a>
        </li>
        </ul>
    </li> 
    <li id='events'
     onClick={(e) => {
        document.getElementById('events').classList.toggle('show');
        setSubMenuOpen(!subMenuOpen);
    }}
    >
        <div class="icon-link">
        <a href="#">
            <i class="float-end"><FaPhotoVideo /></i>
            <span class="link-name">Events </span>
        </a>
        <i class="arrow" > {document.getElementById('events') && document.getElementById('events').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
        </div>

        <ul class="sub-menu">
        <li
        onClick={()=> {
            Navigate('create_event')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaPlus className='me-1' />
                New Event
            </a>
        </li>
        <li
        onClick={()=> {
            Navigate('events')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaPhotoVideo className='me-1' />
                View Events
            </a>
        </li>
        </ul>
    </li>
    <li id='units'
     onClick={(e) => {
        document.getElementById('units').classList.toggle('show');
        setSubMenuOpen(!subMenuOpen);
    }}
    >
        <div class="icon-link">
        <a href="#">
            <i class="float-end"><FaPhotoVideo /></i>
            <span class="link-name">Units </span>
        </a>
        <i class="arrow" > {document.getElementById('units') && document.getElementById('units').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
        </div>

        <ul class="sub-menu">
        <li
        onClick={()=> {
            Navigate('new_unit')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaPlus className='me-1' />
                New Unit
            </a>
        </li>
        <li
        onClick={()=> {
            Navigate('units')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaPhotoVideo className='me-1' />
                View Units
            </a>
        </li>
        </ul>
    </li>
    <li id='gallery'
     onClick={(e) => {
        document.getElementById('gallery').classList.toggle('show');
        setSubMenuOpen(!subMenuOpen);
    }}
    >
        <div class="icon-link ">
        <a href="#">
            <i class="float-end"><FaPhotoVideo /></i>
            <span class="link-name">Gallery </span>
        </a>
        <i class="arrow" > {document.getElementById('gallery') && document.getElementById('gallery').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
        </div>

        <ul class="sub-menu">
        <li
        onClick={()=> {
            Navigate('new_gallery_image')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaPlus className='me-1' />
                Add Photos
            </a>
        </li>
        <li
        onClick={()=> {
            Navigate('gallery')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaPhotoVideo className='me-1' />
                View Gallery
            </a>
        </li>
        </ul>
    </li>
    <li id='users'
     onClick={(e) => {
        document.getElementById('users').classList.toggle('show');
        setSubMenuOpen(!subMenuOpen);
    }}
    >
        <div class="icon-link">
        <a href="#"  >
            <i><FaUsers /></i>
            <span class="link-name">Members</span>
        </a>
        <i class="arrow" > {document.getElementById('users') && document.getElementById('users').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
        
        </div>

        <ul class="sub-menu">
        <li
        onClick={()=> {
            Navigate('new_member')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaPlus className='me-1' />
                New Member
            </a>
        </li>
        <li
        onClick={()=> {
            Navigate('Members')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaList className='me-1' />
                Members List
            </a>
        </li>
        </ul>
    </li>
    <li onClick={()=> {
        Navigate('/messages')
        // console.log(window.innerWidth);
        if(window.innerWidth < '430'){
            let sidebar = document.querySelector(".sidebar");
            sidebar.classList.toggle("close");
        }
        }}>
        <a href="#">
        <i class=""><FaMailBulk /></i>
        <span class="link-name">Messages</span>
        </a>
    </li>
    {/* <li id='message'
     onClick={(e) => {
        document.getElementById('message').classList.toggle('show');
        setSubMenuOpen(!subMenuOpen);
    }}
    >
        <div class="icon-link">
        <a href="#"  >
            <i><FaMailBulk /></i>
            <span class="link-name"> Messages </span>
        </a>
        <i class="arrow" > {document.getElementById('message') && document.getElementById('message').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
        
        </div>

        <ul class="sub-menu">
        <li
        onClick={()=> {
            // Navigate('today_messages')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaPlus className='me-1' />
            Today Messages
            </a>
        </li>
        <li
        onClick={()=> {
            // Navigate('messages')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaList className='me-1' />
             View All Messages
            </a>
        </li>
        </ul>
    </li> */}
    {/* <li id='about'
     onClick={(e) => {
        document.getElementById('about').classList.toggle('show');
        setSubMenuOpen(!subMenuOpen);
    }}
    >
        <div class="icon-link">
        <a href="#"  >
            <i><FaMailBulk /></i>
            <span class="link-name"> About </span>
        </a>
        <i class="arrow" > {document.getElementById('about') && document.getElementById('about').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
        
        </div>

        <ul class="sub-menu">
        <li
        onClick={()=> {
            Navigate('about')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaPlus className='me-1' />
            Update About BSC
            </a>
        </li>
        <li
        onClick={()=> {
            // Navigate('messages')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaList className='me-1' />
             View About BSC
            </a>
        </li>
        </ul>
    </li> */}
    <li onClick={()=> {
        Navigate('/update_about')
        // console.log(window.innerWidth);
        if(window.innerWidth < '430'){
            let sidebar = document.querySelector(".sidebar");
            sidebar.classList.toggle("close");
        }
        }}>
        <a href="#">
        <i class=""><FaHistory /></i>
        <span class="link-name">About BSC</span>
        </a>

        <ul class="sub-menu blank">
        <li><a href="#" class="link-name">about BSC</a></li>
        </ul>
    </li>
    <li onClick={()=> {
        Navigate('/constitution')
        // console.log(window.innerWidth);
        if(window.innerWidth < '430'){
            let sidebar = document.querySelector(".sidebar");
            sidebar.classList.toggle("close");
        }
        }}>
        <a href="#">
        <i class=""><FaBook /></i>
        <span class="link-name">BSC Constitution</span>
        </a>

        <ul class="sub-menu blank">
        <li><a href="#" class="link-name">BSC Constitution</a></li>
        </ul>
    </li>
    <li id='payment'
     onClick={(e) => {
        document.getElementById('payment').classList.toggle('show');
        setSubMenuOpen(!subMenuOpen);
    }}
    >
        <div class="icon-link ">
        <a href="#">
            <i class="float-end"><FaCreditCard /></i>
            <span class="link-name">Payments </span>
        </a>
        <i class="arrow" > {document.getElementById('payment') && document.getElementById('payment').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
        </div>

        <ul class="sub-menu">
        <li><a href="#">
            <FaPoll className='me-1' />
            Today Payments
        </a></li>
        <li><a href="#">
            <FaPollH className='me-1' />
            All Payments
        </a></li>
        </ul>
    </li>

    <li id='settings'
     onClick={(e) => {
        document.getElementById('settings').classList.toggle('show');
        setSubMenuOpen(!subMenuOpen);
    }}
    >
        <div class="icon-link ">
        <a href="#">
            <i class="float-end"><FaCog /></i>
            <span class="link-name">Settings </span>
        </a>
        <i class="arrow" > {document.getElementById('settings') && document.getElementById('settings').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
        </div>

        <ul class="sub-menu">
        <li
        onClick={()=> {
            Navigate('/profile')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaUser className='me-1' />
                User Profile
            </a>
        </li>
        <li
        onClick={()=> {
            Navigate('change_password')
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}
        >
            <a href="#">
            <FaKey className='me-1' />
                Change Password
            </a>
        </li>
        </ul>
    </li>
    

    {/* Side Nav Footer */}
    <div class="profile-details">
        {/* <div class="profile-content">
            <img src="logo.png" alt="" />
        </div>

        <div class="name-job">
            <div class="name">by uxtech</div>
            <div class="job text-center"> www.uxtech.ng </div>
        </div> */}
        {/* <i class="fas fa-right-to-bracket"></i> */}
    </div>
    </ul>
    </div>
  )
}

export default SideNav